import React, { useState } from 'react';
import './Dashboard.css';

function Dashboard() {
  const [timeRange, setTimeRange] = useState('week');

  // Mock data
  const stats = {
    symptomsLogged: 12,
    quizzesCompleted: 5,
    migraineDays: 3,
    avgSeverity: 6.2
  };

  const recentSymptoms = [
    { date: '2025-10-08', time: '14:30', severity: 7, triggers: ['Stress', 'Lack of sleep'] },
    { date: '2025-10-07', time: '09:15', severity: 5, triggers: ['Bright lights'] },
    { date: '2025-10-05', time: '16:45', severity: 8, triggers: ['Weather change', 'Stress'] }
  ];

  const upcomingQuiz = {
    title: 'Daily Mood & Behavior Check',
    dueIn: '2 hours',
    questions: 8
  };

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h2>Welcome back, Sanne</h2>
        <p className="dashboard-subtitle">Here's your health overview</p>
      </div>

      {/* Quick Stats */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">📝</div>
          <div className="stat-content">
            <h3>{stats.symptomsLogged}</h3>
            <p>Symptoms Logged</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">🧠</div>
          <div className="stat-content">
            <h3>{stats.quizzesCompleted}</h3>
            <p>Quizzes Completed</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">📊</div>
          <div className="stat-content">
            <h3>{stats.migraineDays}</h3>
            <p>Migraine Days</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">⚠️</div>
          <div className="stat-content">
            <h3>{stats.avgSeverity}/10</h3>
            <p>Avg Severity</p>
          </div>
        </div>
      </div>

      {/* Time Range Selector */}
      <div className="time-range-selector">
        <button 
          className={timeRange === 'week' ? 'active' : ''}
          onClick={() => setTimeRange('week')}
        >
          This Week
        </button>
        <button 
          className={timeRange === 'month' ? 'active' : ''}
          onClick={() => setTimeRange('month')}
        >
          This Month
        </button>
        <button 
          className={timeRange === 'year' ? 'active' : ''}
          onClick={() => setTimeRange('year')}
        >
          This Year
        </button>
      </div>

      <div className="dashboard-grid">
        {/* Recent Symptoms */}
        <div className="dashboard-card">
          <h3>Recent Symptoms</h3>
          <div className="symptoms-list">
            {recentSymptoms.map((symptom, index) => (
              <div key={index} className="symptom-item">
                <div className="symptom-header">
                  <span className="symptom-date">{symptom.date} at {symptom.time}</span>
                  <span className={`severity-badge severity-${symptom.severity >= 7 ? 'high' : symptom.severity >= 4 ? 'medium' : 'low'}`}>
                    Severity: {symptom.severity}/10
                  </span>
                </div>
                <div className="symptom-triggers">
                  {symptom.triggers.map((trigger, i) => (
                    <span key={i} className="trigger-tag">{trigger}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Upcoming Quiz */}
        <div className="dashboard-card highlight">
          <h3>Upcoming Assessment</h3>
          <div className="quiz-reminder">
            <div className="quiz-icon">🧠</div>
            <h4>{upcomingQuiz.title}</h4>
            <p className="quiz-due">Due in {upcomingQuiz.dueIn}</p>
            <p className="quiz-info">{upcomingQuiz.questions} questions • ~3 minutes</p>
            <button className="quiz-btn">Start Now</button>
          </div>
        </div>

        {/* Weekly Pattern */}
        <div className="dashboard-card full-width">
          <h3>Weekly Pattern</h3>
          <div className="chart-placeholder">
            <div className="chart-bars">
              {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day, index) => {
                const height = Math.random() * 100;
                return (
                  <div key={day} className="bar-container">
                    <div 
                      className="bar" 
                      style={{ height: `${height}%` }}
                      title={`${day}: ${Math.round(height)}%`}
                    ></div>
                    <span className="bar-label">{day}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;


